import React, { useEffect, useRef, useState } from "react";

import {
  TextureLoader,
  PMREMGenerator,
  WebGLCubeRenderTarget,
  CubeCamera,
  RGBAFormat,
  LinearMipmapLinearFilter,
} from "three";
import { gsap } from "gsap";
import effectController from "./Enviroment/effectsController";
import ButtonWithIcon from "./ButtonWithIcon";
import { presets } from "./Presets";

//   const groundProjectedEnv = new GroundProjectedEnv(environmentTexture, {
//   radius: 100,    // Size of the ground projection area
//   height: 10,     // Height offset of the ground plane  
//   scale: 1        // Scale factor for the projection
// });

// // Add to scene
// scene.add(groundProjectedEnv);

// // Set as environment map
// scene.environment = groundProjectedEnv.texture;

// // Optional: Set as background too
// scene.background = groundProjectedEnv.texture;
const EnvironmentManager = ({
  scene,
  renderer,
  selectedFloor,
  isRtl,
  projectImages,
  // environmentUrl,
  setSelectedFloor,
  models,
  floors,
  environmentPreset,
  animationEnded,
  showEnvironment,
}) => {
  const cubeCameraRef = useRef();
  //
  const [selectedImage, setSelectedImage] = useState(null);
  const loader = useRef(new TextureLoader());
  const ldrCubeMap = useRef(null);
  const pmremGenerator = useRef(new PMREMGenerator(renderer));
  //   const [doAnimation, setDoAnimation] = useState(false);
  const doAnimation = useRef(false);
  const textures = useRef({});
  const intervalRef = useRef();
  const lastPreset = useRef();
  useEffect(() => {
    createEnvironmentFromScene();
    // animate();
  }, []);
  useEffect(() => {
    if (animationEnded) {
      console.log('Animation ended')
      updateEnvironment();
    }

  }, [animationEnded])

  useEffect(() => {
    console.log("selectedFloor", selectedFloor);
    if (selectedFloor && selectedFloor.images && selectedFloor.images.length > 0) {

      loadEnvironment(selectedFloor.images[0].url);
      setSelectedImage(selectedFloor.images[0].name);
    } else {
      handlePresetChange(lastPreset.current)
      handleShowEnvironmentChange();
    }

    return () => { };
  }, [selectedFloor]);
  useEffect(() => {
    lastPreset.current = environmentPreset;
    handlePresetChange();
    return () => { };
  }, [environmentPreset]);

  useEffect(() => {
    handleShowEnvironmentChange();
  }, [showEnvironment]);

  const handleShowEnvironmentChange = () => {
        console.log("showEnvironment", showEnvironment);
    if (!showEnvironment) {
      scene.background = null;
      scene.environment = null;
    } else {
      handlePresetChange(lastPreset.current)
      setTimeout(() => {
        updateEnvironment();
      }, 1000);
      // createEnvironmentFromScene();
    }

  };
  const animate = () => {
    // console.log(doAnimation.current)
    requestAnimationFrame(animate);
    if (doAnimation.current) {
      // console.log("anim");
      updateEnvironment();
    }

  };
  const updateEnvironment = () => {
    // console.log("updateEnvironment");
    if (cubeCameraRef.current) {
      cubeCameraRef.current.update(renderer, scene);
      scene.environment = cubeCameraRef.current.renderTarget.texture;
    }
  };
  const handlePresetChange = () => {
    console.log("handlePresetChange", environmentPreset, projectImages);
    const image = projectImages ? projectImages.find(img => img.name.toLowerCase() === environmentPreset.toLowerCase()) : null;
    console.log("image", image);
    if (image) {
      loadEnvironment(image.url);
      // setSelectedImage(environmentPreset);
      return;
    }
    // updateEnvironment();
    // console.log("selectedFloor", selectedFloor);
    // console.log("floors", floors);
    // if (effectController[environmentPreset]) {
    //   // console.log('Setting do animatation to true')
    //   doAnimation.current = true;
    //   if (intervalRef.current) {
    //     clearTimeout(intervalRef.current);
    //   }
    //   intervalRef.current = setTimeout(() => {
    //     // console.log('Setting do animatation to false')
    //     doAnimation.current = false;
    //   }, 3000);
    // }
   
  };


  const loadEnvironment = async (src) => {
    console.log("Loading environment", src);
    // scene.background = null;
    if (textures.current[src]) {
      scene.background = textures.current[src];
      scene.environment = textures.current[src];
      return;
    }
    const equirectangularTexture = await new Promise((resolve, reject) => {
      loader.current.load(src, resolve, undefined, reject);
    });

    pmremGenerator.current.compileEquirectangularShader();
    const ldrCubeRenderTarget = pmremGenerator.current.fromEquirectangular(
      equirectangularTexture
    );
    // console.log({ ldrCubeRenderTarget });
    // ldrCubeMap.current = ldrCubeRenderTarget.texture;
    textures.current = {
      [src]: ldrCubeRenderTarget.texture,
    };
    scene.background = ldrCubeRenderTarget.texture;
    scene.environment = ldrCubeRenderTarget.texture;
    
  };
  const createEnvironmentFromScene = () => {
    console.log("createEnvironmentFromScene", models);
    // Create a cube camera at the specified point
    const cubeRenderTarget = new WebGLCubeRenderTarget(256, {
      format: RGBAFormat,
      generateMipmaps: true,
      minFilter: LinearMipmapLinearFilter,
    });
    cubeCameraRef.current = new CubeCamera(1, 10001, cubeRenderTarget);
    cubeCameraRef.current.position.set(0, 400, 0);
    scene.add(cubeCameraRef.current);

    // models.length && models.forEach((model) => {
    //   model.visible = false;
    // });
    cubeCameraRef.current.update(renderer, scene);
    // models.length && models.forEach((model) => {
    //   model.visible = true;
    // });
    // console.log(cubeCameraRef.current.renderTarget.texture);
    scene.environment = cubeCameraRef.current.renderTarget.texture;
  };

  // if (environmentPreset !== 'Floors') return null;
  const FloorImages = () => {
    if (!selectedFloor) return null;
    const dayPreset = presets.find((preset) => preset.name.toLowerCase() === "day");
    return <>

      {/* <ButtonWithIcon

        icon={dayPreset.icon}
        text={dayPreset.name}
        onClick={() => loadEnvironment(selectedFloor.image)}
        active={false}
      /> */}
      {selectedFloor.images && selectedFloor.images.map((img, index) => {
        // console.log("img", img);
        const preset = presets.find((preset) => preset.name.toLowerCase() === img.name);
        return (
          <ButtonWithIcon

            key={index}
            icon={preset.icon}
            text={preset.name}
            onClick={() => loadEnvironment(img.url)}
            active={ selectedImage === img.name}
          />

        );
      })}
    </>
  };
    const positionStyle = {
      left: isRtl ? ".3rem" : "auto",
      right: isRtl ? "auto" : "-.3rem",
    }
  return (
    <div className="floorsController" style={positionStyle}>
      {/* <Buttons setFloor={setSelectedFloor} /> */}
      {selectedFloor && <FloorImages />}
    </div>
  );
};

export default EnvironmentManager;
